import { useState } from 'react';
import {
  loginWithGoogle,
  loginWithEmail,
  registerWithEmail,
  requestPasswordReset,
} from '../services/authService';
import { translations } from '../locales/translations';
import ReCAPTCHA from 'react-google-recaptcha';
import { useNavigate } from 'react-router-dom';

const AuthModal = () => {
const [isRegister, setIsRegister] = useState(false);
const [email, setEmail] = useState('');
const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState('');
const [captchaValue, setCaptchaValue] =
useState<string | null>(null);
const navigate = useNavigate();
// Language setup
const language = localStorage.getItem('language') || 'pt';
const t = translations[language as keyof typeof translations];
const handleGoogle = async () => {
    try {
      setLoading(true);
      await loginWithGoogle();} 
      catch (error) {console.error(error);
      const err = error as Error;
      if (err.message ===
      'ACCOUNT_BANNED') {
      navigate('/blocked');
      return;}
      setFeedback(err.message || 'Não foi possível entrar com Google.');

} finally {
      setLoading(false);
    }
  };

  const handleEmailAuth = async () => {
    if (!captchaValue) {
  setFeedback('Confirme o reCAPTCHA.');
  return;
}
    try {
      setLoading(true);

      if (isRegister) {
        await registerWithEmail(email, password);
        setFeedback('Enviamos um link de verificação para seu email.');
      } else {
        await loginWithEmail(email, password);
      }
    } catch (error) {
      console.error(error);
     const err = error as Error;

if (err.message.includes('email-already-in-use')) {

  setFeedback(t.emailAlreadyInUse);

} else if (
err.message ===
'ACCOUNT_BANNED'
) {

  navigate(
  '/blocked'
);

  return;

} else {
setFeedback(err.message || 'Não foi possível concluir a autenticação.');

}
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordReset = async () => {
    if (!email.trim()) {
      setFeedback('Informe seu email para recuperar a senha.');
      return;
    }

    try {
      setLoading(true);
      await requestPasswordReset(email);
      setFeedback('Se existir uma conta para este email, enviaremos as instruções de recuperação.');
    } catch (error) {
      console.error(error);
      setFeedback('Não foi possível solicitar a recuperação de senha. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
      <div className="w-full max-w-md bg-dark-800 border border-dark-700 rounded-2xl p-8 shadow-2xl">

        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white mb-2">
            {t.appTitle}
          </h1>

          <p className="text-dark-300">
            {t.appDescription}
          </p>
        </div>

        <div className="space-y-4">

          {feedback && (
            <div className="rounded-lg border border-red-500/40 bg-red-950/50 px-3 py-2 text-sm text-red-100" role="alert">
              {feedback}
            </div>
          )}

          <button
            onClick={handleGoogle}
            disabled={loading}
            className="w-full h-14 rounded-xl bg-white text-black font-semibold hover:bg-gray-200 transition-all"
          >
            {t.continueWithGoogle}
          </button>

          <div className="flex items-center gap-3">
            <div className="flex-1 h-px bg-dark-600" />
            <span className="text-dark-400 text-sm">{t.or}</span>
            <div className="flex-1 h-px bg-dark-600" />
          </div>

          <input
            type="email"
            placeholder={t.emailPlaceholder}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full h-14 px-4 rounded-xl bg-dark-900 border border-dark-700 text-white outline-none focus:border-purple-500"
          />

          <input
            type="password"
            placeholder={t.passwordPlaceholder}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full h-14 px-4 rounded-xl bg-dark-900 border border-dark-700 text-white outline-none focus:border-purple-500"
          />
<ReCAPTCHA
  sitekey="6LcbX-MsAAAAAEfncBNvjuoG3Z1_aKcK9B2h6GpL"
  onChange={(value: string | null) =>
    setCaptchaValue(value)
  }
/>
          <button
            onClick={handleEmailAuth}
            disabled={loading}
            className="w-full h-14 rounded-xl bg-purple-600 text-white font-semibold hover:bg-purple-700 transition-all"
          >
            {isRegister ? t.createAccount : t.signIn}
          </button>

          {!isRegister && (
            <button
              type="button"
              onClick={handlePasswordReset}
              disabled={loading}
              className="w-full text-sm text-purple-400 hover:text-purple-300 transition-all disabled:opacity-50"
            >
              Esqueceu sua senha?
            </button>
          )}

          <button
            onClick={() => setIsRegister(!isRegister)}
            className="w-full text-sm text-purple-400 hover:text-purple-300 transition-all"
          >
            {isRegister
              ? t.alreadyHaveAccount
              : t.dontHaveAccount}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
